{
    "StatusNotReceived": "Empfangener Status war nicht OK.",
    "NAME": "LanguageFallbackNav"
}